import React, { Component } from "react";
import LachakToranjRug from "./lachakToranjRug";
import AfshanRug from "./afshanRug";
import KheshtiRug from "./kheshtiRug";
import ModernRug from "./modernRug";

export default class RugTemplate extends Component {
  render() {
    switch (this.props.rug.rug_type) {
      case "lachak-toranj":
        return (
          <LachakToranjRug
            background={this.props.rug.background}
            border={this.props.rug.border}
            corner={this.props.rug.corner}
            toranj={this.props.rug.toranj}
            show={this.props.show}
          />
        );
      case "afshan":
        return (
          <AfshanRug
            background={this.props.rug.background}
            border={this.props.rug.border}
            show={this.props.show}
          />
        );
      case "kheshti":
        return (
          <KheshtiRug
            background={this.props.rug.background}
            tile={this.props.rug.tile}
            show={this.props.show}
          />
        );
      case "modern":
        return (
          <ModernRug
            background={this.props.rug.background}
            pattern={this.props.rug.pattern}
            show={this.props.show}
          />
        );
      default:
        return <div></div>;
    }
  }
}
